import { Link } from "react-router-dom";
import { Ship, ArrowLeft } from "lucide-react";

export function LegalLayout({ title, updated, children }) {
  return (
    <div className="min-h-screen bg-cream">
      <header className="border-b-2 border-ink bg-sunny">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" data-testid="legal-home-link" className="flex items-center gap-2.5">
            <div className="h-9 w-9 bg-orange border-2 border-ink rounded-xl flex items-center justify-center shadow-nb-sm">
              <Ship className="h-5 w-5 text-white" />
            </div>
            <span className="font-display font-700 text-xl tracking-tight">Tugboat</span>
          </Link>
          <Link to="/" className="flex items-center gap-2 text-sm font-700 hover:text-orange transition-colors">
            <ArrowLeft className="h-4 w-4" /> Back home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-14">
        <h1 className="font-display text-4xl sm:text-5xl font-700 tracking-tight mb-2">{title}</h1>
        <p className="text-sm text-ink/50 font-700 mb-10">Last updated: {updated}</p>
        <div className="space-y-7 text-ink/80 font-600 leading-relaxed">{children}</div>
      </main>

      <footer className="border-t-2 border-ink py-8 text-center text-sm text-ink/60 font-700">
        <div className="flex items-center justify-center gap-4">
          <Link to="/privacy" className="hover:text-orange">Privacy</Link>
          <Link to="/terms" className="hover:text-orange">Terms</Link>
          <span className="text-ink/30">·</span>
          <a href="mailto:hello@tugboatapp.com" className="hover:text-orange">hello@tugboatapp.com</a>
        </div>
      </footer>
    </div>
  );
}

export function LegalSection({ heading, children }) {
  return (
    <section>
      <h2 className="font-display font-700 text-xl text-ink mb-2">{heading}</h2>
      <div className="space-y-3 text-[15px]">{children}</div>
    </section>
  );
}
